function loadCSS(href) {
  // Arguments explained:
  // `href` is the URL for your CSS file.
  // `before` optionally defines the element we'll use as a reference for injecting our <link>
  // By default, `before` uses the first <script> element in the page.
  // However, since the order in which stylesheets are referenced matters, you might need a more specific location in your document.
  // If so, pass a different reference element to the `before` argument and it'll insert before that instead
  // note: `insertBefore` is used instead of `appendChild`, for safety re: http://www.paulirish.com/2011/surefire-dom-element-insertion/
  var ss = window.document.createElement('link');
  var ref = window.document.getElementsByTagName('head')[ 0 ];
  ss.rel = 'stylesheet';
  ss.href = href;
  // temporarily, set media to something non-matching to ensure it'll fetch without blocking render
  ss.media = 'only x';
  // inject link
  ref.appendChild(ss);
  // set media back to `all` so that the styleshet applies once it loads
  setTimeout(function() {
    ss.media = 'all';
  }, 0);
}

module.exports = loadCSS;
